/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum EyebrowStyleEnum {
    BAR = 'BAR',
    TAG = 'TAG',
    KICKER = 'KICKER',
    PILL = 'PILL',
}